// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-list_default__3t7ex"};